import { render, staticRenderFns } from "./IngredientInfoModal.vue?vue&type=template&id=90a8232e&scoped=true"
import script from "./IngredientInfoModal.vue?vue&type=script&lang=js"
export * from "./IngredientInfoModal.vue?vue&type=script&lang=js"
import style0 from "./IngredientInfoModal.vue?vue&type=style&index=0&id=90a8232e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a8232e",
  null
  
)

export default component.exports